<app-header></app-header>
<app-sidebar *ngIf="!hideSidebar"></app-sidebar>
<div class="oi-main-page" [ngClass]="{
    'pagefixd': !hideSidebar && sidebarVisibility,
    'no-sidebar': hideSidebar
  }">
    <router-outlet></router-outlet>
</div>